import { application } from "../controllers/application"
import { CursorConverterController } from "../features/cursor_converter"

application.register("cursor-converter", CursorConverterController)
